import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";
import { SERVICE_AREAS } from "@/data/content";

const Group = ({ title, towns }) => (
  <div className="rounded-3xl border border-slate-200/70 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)]" data-testid={`area-group-${title.toLowerCase()}`}>
    <div className="mb-5 flex items-center gap-3">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-700 text-white"><MapPin size={18} /></span>
      <h3 className="font-display text-2xl font-bold text-slate-900">{title}</h3>
    </div>
    <div className="flex flex-wrap gap-2">
      {towns.map((t) => (
        <span key={t} className="group flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-emerald-300 hover:bg-emerald-50 hover:text-emerald-800" data-testid={`area-${t.toLowerCase().replace(/\s+/g, "-")}`}>
          {t}
          <ArrowUpRight size={13} className="text-emerald-500 opacity-0 transition-opacity group-hover:opacity-100" />
        </span>
      ))}
    </div>
  </div>
);

export const ServiceAreas = () => (
  <section id="service-areas" className="bg-slate-50 py-20 sm:py-28" data-testid="service-areas-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-widest text-emerald-700">Where we clean</p>
        <h2 className="mt-3 font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">Service Areas</h2>
        <p className="mt-4 max-w-2xl text-lg text-slate-600">
          We provide end-of-tenancy and move-out cleaning across Dublin, County Kildare and nearby
          areas. Availability depends on the date, property size and travel distance.
        </p>
      </Reveal>
      <Stagger className="mt-12 grid gap-6 lg:grid-cols-2">
        <StaggerItem><Group title="Dublin" towns={SERVICE_AREAS.Dublin} /></StaggerItem>
        <StaggerItem><Group title="Kildare" towns={SERVICE_AREAS.Kildare} /></StaggerItem>
      </Stagger>
    </div>
  </section>
);
